import Vue from 'vue'
import {UTC, isDayEqual, s2ab} from '@/utils'
import {stateHexColors} from '@/colorTypes'
import i18n from '@/i18n'

const initialState = {
  loading: false,
  employeeExecutionData: [],
  employeesDocsByStateData: [],
  employeeGanttData: {
    documents: []
  },
  employeesOverdueDocumentsByRegisterBooksData: [],
  shortBySendersData: {},
  expiringDocsByRegisterBooksData: [],
  appealsByCategoriesAndRegionsData: [],
  exportData: null,
  emtByStates: [],
  emtByTermDate: [],
  totalTasksByState: [],
  totalTasksByAD: [],
  tasksByDays: [],
  tasksByMonth: [],
  aDashboard: {
    period: 'month',
    ePeriod: 'month',
    aPeriod: 'day'
  }
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  getters: {
    employeeExecutionDataByDepartment(state) {
      let result = []
      state.employeeExecutionData.map((employee) => {
        if (!(employee.department_id in result)) {
          result[employee.department_id] = {
            name: employee.department__name,
            items: []
          }
        }
        result[employee.department_id].items.push(employee)
      })
      return result
    },
    employeeGantt(state) {
      let result = []
      state.employeeGanttData.documents.map((document) => {
        result.push({
          name: document.name,
          id: `document_${document.id}`,
          owner: document.author__initials,
          start: UTC(document.start_date),
          end: UTC(document.end_date),
          state: i18n.t(`workflow.states.${document.state}`),
          color: stateHexColors[document.state]
        })
        document.tasks.map((task) => {
          result.push({
            name: `Задача №${task.id}`,
            id: `task_${task.id}`,
            parent: `document_${document.id}`,
            owner: document.author__initials,
            milestone: isDayEqual(task.start_date, task.end_date),
            start: UTC(task.start_date),
            end: UTC(task.end_date),
            state: i18n.t(`workflow.states.${task.state}`),
            color: stateHexColors[task.state]
          })
        })
      })
      return [{name: '', data: result}]
    }
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    SET_EXPORT_DATA(state, exportData) {
      state.exportData = new Blob([s2ab(atob(exportData))], {
        type: ''
      });
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getEmployeeExecution({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_execution_report/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'employeeExecutionData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getEmployeeGantt({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employee_execution_gantt_report/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'employeeGanttData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getEmployeesOverdueDocumentsByRegisterBooks({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/docflow/employee_overdue_docs_by_register_books/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'employeesOverdueDocumentsByRegisterBooksData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    shortBySenders({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/docflow/short_report_by_senders/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'shortBySendersData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    expiringDocsByRegisterBooks({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/docflow/expiring_docs_by_register_books/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'expiringDocsByRegisterBooksData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    appealsByCategoriesAndRegions({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/docflow/appeals_by_categories_and_regions/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'appealsByCategoriesAndRegionsData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    employeesDocsByState({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/docflow/employees_docs_by_state/`, {params}).then(response => {
          if (params.export)
            commit('SET_EXPORT_DATA', response.data)
          else
            commit('SET', {key: 'employeesDocsByStateData', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    emtByStates({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_tasks_by_analytic_dimensions_and_states/`, {
          params: {
            period: state.aDashboard.period
          }
        }).then(response => {
          commit('SET', {key: 'emtByStates', val: response.data.sort((a, b) => a.id - b.id)})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    emtByTermDate({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_tasks_by_analytic_dimensions_and_term_date/`, {params}).then(response => {
          commit('SET', {key: 'emtByTermDate', val: response.data.sort((a, b) => a.id - b.id)})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    totalTasksByState({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_tasks_total_by_states/`, {
          params: {
            period: state.aDashboard.ePeriod
          }
        }).then(response => {
          commit('SET', {key: 'totalTasksByState', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    totalTasksByAD({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_total_tasks_by_analytic_dimensions/`, {
          params: {
            period: state.aDashboard.ePeriod
          }
        }).then(response => {
          commit('SET', {key: 'totalTasksByAD', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    tasksByDays({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_task_states_by_dates/`).then(response => {
          commit('SET', {key: 'tasksByDays', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    tasksByMonth({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reports/workflow/employees_task_states_by_months/`).then(response => {
          commit('SET', {key: 'tasksByMonth', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
  }
}
